import { Avatar, Button, Stack, Typography } from '@mui/material';
import { ReferralRequest } from '../../Summary/RequestSharePanel/ReferralRequest';
import { OutlinedWhitePhone } from 'Images';
import { useNavigate } from 'react-router-dom';
import React from 'react';

interface IMobileContactDetails {
  contacts: {
    cellPhoneNumber: string | null;
    homePhoneNumber: string | null;
    email: string;
  };
}

export const MobileContactDetails = ({ contacts }: IMobileContactDetails) => {
  const navigate = useNavigate();

  const contactNumber = contacts.cellPhoneNumber || contacts.homePhoneNumber;

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      sx={{ mt: '24px' }}
    >
      {contactNumber !== null && (
        <Button
          onClick={(event: React.MouseEvent) => event.stopPropagation()}
          href={`tel:${contactNumber}`}
          sx={{
            p: '6px 16px',
            display: 'flex',
            gap: '4px',
            bgcolor: 'primary.shade_400',
            borderRadius: '100px',
            maxWidth: '136px',
            ':hover': {
              bgcolor: 'primary.shade_400',
            },
          }}
        >
          <Avatar
            alt=''
            src={OutlinedWhitePhone}
            sx={{ width: '20px', height: '20px' }}
          />
          <Typography
            variant='body4'
            sx={{ color: '#FFF', whiteSpace: 'nowrap' }}
          >
            {contactNumber}
          </Typography>
        </Button>
      )}
      <ReferralRequest onClick={() => navigate('/universalRequest/1/1/77')} />
    </Stack>
  );
};
